import type { Key } from "./dictionary";
import { balootTr } from "./dictionary.baloot";
import { cardTr } from "./dictionary.card";
import { heartsTr } from "./dictionary.hearts";
import { homeTr } from "./dictionary.home";
import { kingTr } from "./dictionary.king";
import { languageTr } from "./dictionary.language";
import { matchTr } from "./dictionary.match";
import { pistiTr } from "./dictionary.pisti";
import { rulesTr } from "./dictionary.rules";
import { socialTr } from "./dictionary.social";
import { spadesTr } from "./dictionary.spades";
import { tablesTr } from "./dictionary.tables";

/** Turkish; must cover every English key with the same placeholders (tested). */
export const tr: Record<Key, string> = {
  ...matchTr,
  ...balootTr,
  ...spadesTr,
  ...cardTr,
  ...languageTr,
  ...socialTr,
  ...rulesTr,
  ...heartsTr,
  ...homeTr,
  ...kingTr,
  ...pistiTr,
  ...tablesTr,
  "app.name": "High Card Club",
  "table.bar.trump": "Koz {suit}",
  "table.bar.trumpLabel": "Koz",
  "table.bar.targetLabel": "Hedef",
  "table.bar.handsLabel": "El",
  "table.turn.you": "Sıra sende",
  "table.turn.play": "Sıra sende · oyna",
  "table.turn.other": "{name} oynuyor",
  "table.turn.bidding": "{name} ihale veriyor",
  "table.turn.trump": "{name} koz seçiyor",
  "table.bid.you": "İhale sende",
  "table.trump.forHand": "{amount} el için",
  "table.trump.inHand": "elinde {count}",
  "table.seat.pass": "Pas",
  "table.seat.thinking": "Düşünüyor…",
  "table.seat.waiting": "Bekliyor",
  "table.seat.score": "{score} puan",
  "table.seat.away": "Kopuk · bot oynuyor",
  "table.seat.hand": "elinde {count} kart",
  "table.trick.led": "{name} açtı",
  "table.handEnd.title": "El bitti",
  "table.event.redeal": "Herkes pas: kartlar yeniden dağıtıldı",
  "table.event.contract-forced": "Herkes pas geçti: {name} {amount} oynayacak",
  "table.event.trump-chosen": "Koz {suit}",
  "lobby.seated": "{count} / 4 oturdu",
  "lobby.ready": "Hazır",
  "lobby.empty": "Boş koltuk",
  "lobby.watchers": "{count} izliyor",
  "tooltip.invite": "Arkadaşını davet et",
  "tooltip.sound": "Ses düzeyi",
  "home.scene": "Sahne",
  "scene.orman": "Orman",
  "scene.otel": "Otel",
  "scene.uzay": "Uzay",
  "scene.istanbul": "İstanbul",
  "scene.majlis": "Majlis",
  "scene.neon": "Neon",
  "data.open": "{name} - verilerim",
  "data.title": "Verilerim",
  "data.back": "Geri",
  "data.failed": "Olmadı. Birazdan tekrar dene.",
  "data.legal": "Yasal",
  "data.leaderboard": "Liderlik",
  "data.hide": "Liderlikte adımı gizle",
  "data.hide.about": 'Maçların yine sayılır. Diğerleri adın ve resmin yerine "Gizli oyuncu" görür.',
  "data.usage": "Kullanım ölçümü",
  "data.measure": "Kullanım ölçümüne katıl",
  "data.measure.about":
    "Oyunu açtığın, masaya oturduğun ve maç bitirdiğin günleri sayarız; başka hiçbir şeyi değil. Kapatırsan bu kayıtlar silinir, yenisi tutulmaz.",
  "data.download": "Verilerinin kopyası",
  "data.download.about":
    "Tarayıcında, hakkında tuttuğumuz her şeyin JSON dosyası için bir bağlantı açılır. Bir kez, on dakika çalışır.",
  "data.download.start": "Verilerimi indir",
  "data.delete": "Silme",
  "data.delete.about":
    "30 gün bekleriz, sonra maçların anonimleşir, geri kalan her şey silinir. O güne kadar iptal edebilirsin.",
  "data.delete.start": "Verilerimi sil",
  "data.delete.confirm":
    '30 gün sonra maçların rakiplerin için yalnız "Silinmiş oyuncu" olarak kalır; denemelerin, Club bildirimlerin ve ayarların silinir. O günden sonra geri alınamaz.',
  "data.delete.yes": "30 gün sonra sil",
  "data.delete.keep": "Verilerimi tut",
  "data.delete.pending": "Verilerin {date} tarihinde silinecek.",
  "data.delete.cancel": "Silmeyi iptal et",
  "legal.privacy": "Gizlilik politikası",
  "legal.terms": "Kullanım şartları",
  "legal.notice": "Oynayarak kabul etmiş olursun:",
  "legal.dismiss": "Kapat",
  "leaderboard.hiddenPlayer": "Gizli oyuncu",
  "home.deck": "Deste",
  "deck.classic": "Classic",
  "deck.anime": "Anime",
  "deck.obsidian": "Obsidian",
  "club.badge": "Club",
  "club.new": "Yeni",
  "club.trialOffer": "3 gün ücretsiz",
  "club.starting": "Başlatılıyor…",
  "club.left.days": "Ücretsiz · {count} gün kaldı",
  "club.left.hours": "Ücretsiz · {count} saat kaldı",
  "club.left.minutes": "Ücretsiz · {count} dk kaldı",
  "club.locked": "Club ile geri gelecek",
  "club.notify": "Haber ver",
  "club.notified": "Haber vereceğiz",
  "club.ended.deck": "{name} destesinin deneme süresi bitti. Club ile geri gelecek.",
  "club.ended.scene": "{name} sahnesinin deneme süresi bitti. Club ile geri gelecek.",
  "invite.copied": "Bağlantı kopyalandı",
  "invite.copiedSub": "Arkadaşına gönder, masaya doğrudan gelsin.",
  "table.bar.noTrump": "Koz yok",
  "table.seat.chooseTrump": "ihale {amount} · koz seç",
  "table.bid.canSay": "{name} {amount} dedi · sen {min}+ diyebilirsin",
  "table.bid.open": "Henüz ihale yok · sen {min}+ diyebilirsin",
  "table.bid.note": "Herkes pas geçerse ilk konuşan 4 oynar",
  "table.toast.points": "{points} puan",
  "table.toast.down": "BATTI · {points} puan",
  "table.toast.won": "İhaleyi {amount} ile aldın",
  "table.toast.pickTrump": "şimdi kozunu seç",
  "table.toast.forced": "Herkes pas geçti: {amount} sende",
  "table.gameEnd.meta": "{hands} el · {target}",
  "table.watching.sub": "· maç bitince boşalan koltuğa oturabilirsin",
  "table.connecting.sub": "Koltuğun senin; dönene kadar bot senin yerine oynuyor.",
  "table.leaving": "Masadan ayrılıyorsun…",
  "auth.connecting": "Discord'a bağlanılıyor…",
  "auth.denied": "High Card Club'ın kim olduğunu görmesi için izin gerekiyor.",
  "auth.server": "Masa sunucusu yanıt vermedi.",
  "auth.refresh": "Yeni sürüm hazır. Etkinliği yeniden aç.",
  "auth.retry": "Tekrar dene",
  "update.title": "Yeni sürüm hazır",
  "update.body": "Oynamaya devam etmek için yenile. Maçtaysan koltuğun seni bekliyor.",
  "update.reload": "Yenile",
  "lobby.title": "Lobi",
  "lobby.seat.empty": "Otur",
  "lobby.seat.bot": "Bot",
  "lobby.seat.away": "Uzakta",
  "lobby.settings": "{variant} · {target} · {tempo}",
  "lobby.target.goal": "{goal} puana",
  "lobby.target.length": "{length} el",
  "lobby.fillBots": "Botla doldur",
  "lobby.start": "Hemen başlat",
  "lobby.countdown": "{seconds} saniyede başlıyor",
  "home.title": "Oyun seç",
  "home.subtitle": "Bu kanalın bir masası olur; masayı kuran oyunu seçer.",
  "home.open": "Masayı kur",
  "home.goal": "Hedef",
  "home.hands": "El",
  "home.tempo": "Tempo",
  "home.points": "{goal} puan",
  "home.handsCount": "{length} el",
  "lobby.share.message": "High Card Club'da masama gel",
  "lobby.leaveTable": "Kendi kanalıma dön",
  "profile.loading": "Sicilin yükleniyor…",
  "profile.none": "Henüz maç yok. Bir masa kur.",
  "profile.record": "{matches} maç · {wins} galibiyet",
  "home.heading": "Lobi",
  "home.tab.create": "Masa kur",
  "home.tab.join": "Masalara katıl",
  "home.quick": "Rakip ara: {game}",
  "home.rules": "Masa kuralları",
  "rule.spades.bagPenalty": "Bag cezası",
  "rule.spades.bagPenalty.true": "10 bag = −100",
  "rule.spades.bagPenalty.false": "Ceza yok",
  "rule.tarneeb.trumpLead": "Koz açma",
  "rule.tarneeb.trumpLead.false": "Her zaman",
  "rule.tarneeb.trumpLead.true": "Koz kırılınca",
  "rule.tarneeb.minBid": "Alt ihale",
  "rule.tarneeb.minBid.7": "7",
  "rule.tarneeb.minBid.5": "5",
  "home.who": "Kim katılabilir",
  "home.who.anyone": "Herkes",
  "home.who.invite": "Yalnız davetle",
  "lobby.game": "Oyun",
  "lobby.target.points": "{goal} puana",
  "table.event.contract-won": "{name} ihaleyi {amount} ile aldı",
  "rule.baloot.projects": "Projeler",
  "rule.baloot.projects.true": "Sira, 50, 100, 400",
  "rule.baloot.projects.false": "Yok",
  "rule.baloot.doubling": "Double",
  "rule.baloot.doubling.true": "Double'dan gahwa'ya",
  "rule.baloot.doubling.false": "Yok",
  "tempo.relaxed": "Sakin",
  "tempo.normal": "Normal",
  "tempo.fast": "Hızlı",
  "table.bar.hand": "{hand}. el",
  "table.bar.goal": "{goal} puana",
  "table.bar.length": "/ {length}",
  "table.seat.tricks": "{tricks} el",
  "table.seat.bid": "ihale {amount}",
  "table.seat.turn": "Sıra",
  "table.bid.title": "İhalen",
  "table.bid.pass": "Pas",
  "table.trump.title": "Koz seç",
  "table.hand.title": "Elin",
  "table.watching": "İzliyorsun",
  "table.handEnd.made": "{name} {amount} dedi, tuttu",
  "table.handEnd.failed": "{name} {amount} dedi, battı",
  "table.gameEnd.title": "Maç bitti",
  "table.gameEnd.winner": "Kazanan: {names}",
  "table.again": "Tekrar oyna",
  "table.leave": "Masadan ayrıl",
  "table.trick.winner": "Eli {name} aldı",
  "table.connecting": "Yeniden bağlanılıyor…",
  "suit.spades": "Maça",
  "suit.hearts": "Kupa",
  "suit.diamonds": "Karo",
  "suit.clubs": "Sinek",
  "error.seat-taken": "O koltuk az önce alındı.",
  "error.kicked": "Masa sahibi seni çıkardı. İzlemeye devam edebilirsin.",
  "error.not-owner": "Bunu yalnız masa sahibi yapabilir.",
  "error.not-lobby": "Oyun zaten başladı.",
  "error.look-locked": "Bu seçim kilitli; masa varsayılanla açıldı.",
  "error.spectators-full": "Masa izleyiciyle dolu.",
  "error.generic": "Bir şeyler ters gitti ({code}).",
  "error.boundary": "Bizim tarafta bir şey bozuldu. Etkinliği yeniden yükle.",
  "error.eventId": "Olay kimliği: {id}",
  "error.reload": "Yeniden yükle",
  "home.leaderboard": "Liderlik tablosu",
  "leaderboard.title": "Liderlik tablosu",
  "leaderboard.back": "Geri",
  "leaderboard.periods": "Dönem",
  "leaderboard.period.week": "Hafta",
  "leaderboard.period.month": "Ay",
  "leaderboard.period.all": "Tümü",
  "leaderboard.heading.week": "Haftalık sıralama",
  "leaderboard.heading.month": "Aylık sıralama",
  "leaderboard.heading.all": "Tüm zamanların sıralaması",
  "leaderboard.left.days": "{days} gün {hours} saat kaldı",
  "leaderboard.left.hours": "{hours} saat kaldı",
  "leaderboard.left.soon": "bir saatten az kaldı",
  "leaderboard.record": "{wins}-{losses}",
  "leaderboard.recordName": "{wins} galibiyet, {losses} mağlubiyet",
  "leaderboard.you": "Senin sıran",
  "leaderboard.who": "Kimler sayılıyor",
  "leaderboard.scope.all": "Herkes",
  "leaderboard.scope.guild": "Sunucum",
  "leaderboard.emptyGuild":
    "Sunucundan henüz sıralamaya giren yok. Yalnız dört kişilik masalar sayılır, botlu maçlar sayılmaz.",
  "leaderboard.unranked": "Henüz sıralamada değilsin: dört kişilik bir masada oyna",
  "leaderboard.empty":
    "Henüz sayılan maç yok. Yalnız dört kişilik masalar sayılır, botlu maçlar sayılmaz.",
  "leaderboard.loading": "Sıralama yükleniyor…",
  "leaderboard.error": "Sıralama yüklenemedi.",
  "leaderboard.retry": "Tekrar dene",
  "leaderboard.trend.new": "yeni",
  "leaderboard.trend.up": "{n} sıra yukarı",
  "leaderboard.trend.down": "{n} sıra aşağı",
  "leaderboard.trend.same": "değişmedi",
};
